/** Admin-set caption shown as a gradient band overlaid on the bottom of a
 * photo — not a separate line of text below it. Renders nothing if empty. */
export default function PhotoCaptionOverlay({ text }: { text: string | undefined }) {
  if (!text) return null;

  return (
    <div
      className="absolute inset-x-0 bottom-0 px-3.5 pt-8 pb-2.5 text-paper text-[13px] font-medium leading-snug"
      style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 100%)' }}
    >
      {text}
    </div>
  );
}
